module.exports = require("live/services/global-confirmation");